import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {validators} from '../../../validation';
import Field from '../../Field';
import TextInput from '../../TextInput';
import StateInput from '../../StateInput';
import {
  setAddressLine1,
  setAddressLine2,
  setCity,
  setState,
  setPostalCode,

  setAddressLine1Errors,
  setAddressLine2Errors,
  setCityErrors,
  setStateErrors,
  setPostalCodeErrors
} from '../../../actions/address';
import './AddressForm.less';


const AddressLine1Field = connect(
  state => ({
    value: state.address.Address_Line_1.value,
    errors: state.address.Address_Line_1.errors,
    validators: [validators.required()],
    label: "Line 1"
  }),
  dispatch => ({
    onChange(value) {
      dispatch(setAddressLine1(value));
    },
    setErrors(errors) {
      dispatch(setAddressLine1Errors(errors));
    }
  })
)(Field);

const AddressLine2Field = connect(
  state => ({
    value: state.address.Address_Line_2.value,
    errors: state.address.Address_Line_2.errors,
    validators: [validators.required()],
    label: "Line 2"
  }),
  dispatch => ({
    onChange(value) {
      dispatch(setAddressLine2(value));
    },
    setErrors(errors) {
      dispatch(setAddressLine2Errors(errors));
    }
  })
)(Field);

const CityField = connect(
  state => ({
    value: state.address.City.value,
    errors: state.address.City.errors,
    validators: [validators.required()],
    label: "City"
  }),
  dispatch => ({
    onChange(value) {
      dispatch(setCity(value));
    },
    setErrors(errors) {
      dispatch(setCityErrors(errors));
    }
  })
)(Field);

const StateField = connect(
  state => ({
    value: state.address['State/Region'].value,
    errors: state.address['State/Region'].errors,
    validators: [validators.required()],
    label: "State"
  }),
  dispatch => ({
    onChange(value) {
      dispatch(setState(value));
    },
    setErrors(errors) {
      dispatch(setStateErrors(errors));
    }
  })
)(Field);

const PostalCodeField = connect(
  state => ({
    value: state.address.Postal_Code.value,
    errors: state.address.Postal_Code.errors,
    validators: [validators.required()],
    label: "Zip"
  }),
  dispatch => ({
    onChange(value) {
      dispatch(setPostalCode(value));
    },
    setErrors(errors) {
      dispatch(setPostalCodeErrors(errors));
    }
  })
)(Field);


export default class AddressForm extends PureComponent {
  render() {
    return (
      <div className="address-form">
        <h3>Your Address</h3>
        <AddressLine1Field>
          <TextInput />
        </AddressLine1Field>
        <AddressLine2Field>
          <TextInput />
        </AddressLine2Field>
        <CityField>
          <TextInput />
        </CityField>
        <StateField>
          <StateInput />
        </StateField>
        <PostalCodeField>
          <TextInput />
        </PostalCodeField>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/form-route/forms/AddressForm.js